module.exports = __webpack_public_path__ + "img/img-3.5f268059.jpg";